import { oc } from '@orpc/contract';
import { getTemplateInputSchema, templateDetailSchema } from '../schemas/templates.schemas.js';
export const getTemplateContract = oc
    .route({
    method: 'GET',
    path: '/templates/{templateId}',
    tags: ['Templates'],
    summary: 'One template with every version it has had',
})
    .input(getTemplateInputSchema)
    .output(templateDetailSchema);
//# sourceMappingURL=get-template.contract.js.map